module.exports = __webpack_public_path__ + "img/6.37b32524.png";